"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var encoder_1 = __importDefault(require("./encoder"));
var decoder_1 = __importDefault(require("./decoder"));
var JWT = {
    encode: function (body, key, options) {
        if (options === void 0) { options = {}; }
        var encoder = new encoder_1.default(body, key, options);
        return encoder.encodeAndSign();
    },
    decode: function (token, key, options) {
        if (options === void 0) { options = {}; }
        var decoder = new decoder_1.default(key);
        return decoder.decodeAndVerify(token, options);
    },
};
exports.default = JWT;
